import { render, staticRenderFns } from "./LoggedInRoot.vue?vue&type=template&id=49a5c0b2&"
import script from "./LoggedInRoot.vue?vue&type=script&lang=ts&"
export * from "./LoggedInRoot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports